module.exports = __webpack_public_path__ + "img/dgj_logo.5ff9438e.png";